
define('modules/hypr-fixes/safer',[], function() {var b=window.scc;return function(a){try{return b.safe(a)}catch(c){return console.log(c),a}}}); 